<!-- eslint-disable-next-line custom-rules/no-inner-html-property-binding -->
<div [innerHtml]="this.content | markupString"></div>
